import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  signInWithToken(token) {
    return axiosInstance.post(`/api/security/authentication/login?token=${token}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getUserStatus() {
    return axiosInstance.get('/api/security/authentication/status', {
      cancelToken: getNewCancelToken(),
    });
  },
  setCompany(companyId) {
    return axiosInstance.get(`/api/security/authentication/setcompany/${companyId}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  logout() {
    return axiosInstance.get('/api/security/authentication/logout', {
      cancelToken: getNewCancelToken(),
    });
  },
};
